<template>
    <div>
        <FusionInput :config="input"
                     @controlValueChange="handleChange"
                     @passHiddenStateChanged="handleShownChange"
        />
    </div>
</template>

<script>
import { FusionInput } from '@ironsrc/fusion-ui/native/vue/fusion-vue';
import {
    MANDATORY_ERROR,
    MAX_ERROR,
    MAXLENGTH_ERROR,
    MIN_ERROR,
    PATTERN_ERROR
} from 'services/metaData/errors';

export default {
    name: 'FormInput',
    components: {
        FusionInput
    },
    props: {
        placeholder: {
            type: [String, Number],
            default: ''
        },
        value: {
            type: [String, Number],
            default: null
        },
        inputType: {
            type: String,
            default: 'text',
        },
        icon: {
            type: String
        },
        iconPosition: {
            type: String
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number
        },
        min: {
            type: Number
        },
        max: {
            type: Number
        },
        pattern: {
            type: [String, RegExp]
        },
        patternError: {
            type: String,
            default: PATTERN_ERROR
        },
        isPassHidden: {
            type: Boolean
        },
        showValidationErrors: {
            type: Boolean
        },
        customValidations: {
            type: Array,
            default: () => [],
            validator(value) {
                return !value.find((validation) => !validation.errorMsg || !validation.validationFunc);
            }
        },
        triggerCustomValidationOnChange: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            input: {
                options: {
                    isPassHidden: this.inputType === 'password' ? this.isPassHidden : undefined
                },
                error: '',
                type: this.inputType,
                placeholder: this.placeholder,
                isDisabled: this.isDisabled,
                controlValue: this.value,
                required: this.isRequired,
                maxlength: this.maxLength,
                min: this.min,
                max: this.max,
                icon: this.icon,
                iconPos: this.iconPosition
            }
        };
    },
    watch: {
        isDisabled(newVal) {
            this.input = { ...this.input, isDisabled: newVal };
        },
        isPassHidden(newVal) {
            if (newVal !== this.input.options.isPassHidden) {
                this.input = {
                    ...this.input,
                    options: { isPassHidden: newVal },
                };
            }
        },
        showValidationErrors(newVal) {
            if (newVal) {
                this.input = {
                    ...this.input,
                    error: this.calcError(this.value)
                };
            }
        },
        triggerCustomValidationOnChange() {
            if (this.value) {
                this.input = {
                    ...this.input,
                    error: this.calcCustomError(this.value)
                };
            }
        }
    },
    methods: {
        handleChange(value) {
            this.input.controlValue = value;
            const error = this.calcError(value);
            if (error !== this.input.error) {
                this.input = { ...this.input, error };
            }
            this.$emit('changedValue', { value, isValid: !this.input.error });

            // update v-model
            this.$emit('input', value);
        },
        handleShownChange(value) {
            this.input = {
                ...this.input,
                options: { isPassHidden: value },
            };
            this.$emit('showPasswordChanged', value);
        },
        calcCustomError(value) {
            for (let i = 0; i < this.customValidations.length; i++) {
                if (!this.customValidations[i].validationFunc(value)) {
                    return this.customValidations[i].errorMsg;
                }
            }
            return null;
        },
        calcError(value) {
            if (this.isRequired && !value) {
                return MANDATORY_ERROR;
            }
            if (this.maxLength && value && value.length > this.maxLength) {
                return MAXLENGTH_ERROR.replace('{valuePlaceholder}', this.maxLength);
            }
            if (this.pattern && value && !value.match(this.pattern)) {
                return this.patternError;
            }
            if (this.min && value < this.min) {
                return MIN_ERROR.replace('{valuePlaceholder}', this.min);
            }
            if (this.max && value > this.max) {
                return MAX_ERROR.replace('{valuePlaceholder}', this.max);
            }

            return this.calcCustomError(value);
        }
    }
};
</script>

<style scoped>

</style>
